export const constants = {
  text: {
    fill: 'rgba(255, 255, 255, 0.95)',
    stroke: 'rgba(235, 23, 23, 0.95)',
    strokeWidth: '2',
    strokeDasharray: '',
    opacity: '1',
    fontSize: '16',
    fontFamily: 'Arial, sans-serif',
    fontStyle: 'normal',
    textDecoration: 'none',
    fontWeight: 'normal',
    textAnchor: 'start',
  },
  shape: {
    fill: 'rgba(255, 255, 255, 0)',
    stroke: 'rgba(235, 23, 23, 0.95)',
    strokeWidth: '3',
    strokeDasharray: '',
    opacity: '1',
    fontSize: '16',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: 'none',
    textAnchor: 'start',
  },
  highlighter: {
    fill: 'rgba(255, 255, 0, 0.4)',
    stroke: 'none',
    strokeWidth: '2',
    strokeDasharray: '',
    opacity: '0.5',
    fontSize: '16',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: 'none',
    textAnchor: 'start',
  },
  hyperlink: {
    width: '50',
    height: '50',
  },
};
